import styles from "./ShabbyShasta.module.css";

const ShabbyShasta: React.FC = () => {
  const shabbyShastaImg =
    "https://thehideawayretreat-storage-images234800-staging.s3.amazonaws.com/home-section-five.jpg";
  const shabbyShastaImageAltInfo =
    "Beautiful woman having fun camping in our vintage 1958 camper rental, Shabby Shasta, while enjoying our waterfront RV park in Navarre Florida";

  return (
    <div className={styles.shabbyShastaContainer}>
      <div className={styles.imageWrapper}>
        <img
          src={shabbyShastaImg}
          alt={shabbyShastaImageAltInfo}
          className={styles.image}
        />
      </div>
      <div className={styles.textSection}>
        <div className={styles.textContainer}>
          <div className={styles.rightTitle}>Shabby Shasta</div>
          <div className={styles.rightText}>
            Our 1958 vintage camper rental "Shabby Shasta" will take you back to
            a simpler time. A time to remember.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShabbyShasta;
